<app-auctions-hero></app-auctions-hero>
<app-faq
  section
  sectionId="auctions-faq"
  sectionLabel="FAQ"
  [sectionListable]="true">
</app-faq>
<app-auctions-solutions
  section
  sectionId="auctions-solutions"
  sectionLabel="Rozwiązania"
  [sectionListable]="true">
</app-auctions-solutions>
<app-auctions-bait></app-auctions-bait>
<app-auctions-about
  section
  sectionId="auctions-about"
  sectionLabel="Odkrywaj"
  [sectionListable]="true">
</app-auctions-about>
<app-auctions-offer
  section
  sectionId="auctions-offer"
  sectionLabel="Oferta"
  [sectionListable]="true">
</app-auctions-offer>
<app-auctions-steps></app-auctions-steps>
<app-auctions-form
  section
  sectionId="application-form"
  sectionLabel="Formularz"
  [sectionListable]="true">
</app-auctions-form>
<app-footer></app-footer>
<!--<app-banner></app-banner>-->
